import { render, staticRenderFns } from "./package-product-type-selector.vue?vue&type=template&id=30ef8a3a&"
import script from "./package-product-type-selector.vue?vue&type=script&lang=js&"
export * from "./package-product-type-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports